import Link from 'next/link';
import { type ReactRouterDomLinkProps } from '@johnlewispartnership/wtr-aem-components';

export default function LinkComponent({
  children,
  to,
  ...remainingProps
}: ReactRouterDomLinkProps) {
                                                                                          
                                              

                                                                                                              
                                                                                                               
                                                                                                            
  const href = to as React.ComponentProps<typeof Link>['href'];

  return (
    <Link href={href} {...remainingProps}>
      {children}
    </Link>
  );
}
